import { render, staticRenderFns } from "./MergerAcquistionTable.vue?vue&type=template&id=257c15a5&"
import script from "./MergerAcquistionTable.vue?vue&type=script&lang=ts&"
export * from "./MergerAcquistionTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('257c15a5')) {
      api.createRecord('257c15a5', component.options)
    } else {
      api.reload('257c15a5', component.options)
    }
    module.hot.accept("./MergerAcquistionTable.vue?vue&type=template&id=257c15a5&", function () {
      api.rerender('257c15a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/transactionalData/MergerAcquistionTable.vue"
export default component.exports